<template lang="pug">
v-expansion-panels.event-info(
  flat
  filled
  accordion
  v-model="openedPanel"
)
  v-expansion-panel.event-info__panel(ref="panel")
    v-expansion-panel-header.event-info__header.flex-wrap.gap-8
      div.pr-6
        h3.even-info__title {{ data.name }}
        p.event-info__date
          | {{ data.event_stage_start_at | localeFormatDefault | readableDate }}
          | - {{ data.event_stage_end_at | localeFormatDefault | readableDate }}
      template(v-slot:actions)
        app-button.event-info__btn Правила участия
    v-expansion-panel-content.event-info__content
      .event-info__content-wrapper
        event-info-content(:data="data" @close="unsetOpenedPanel")
</template>

<script>
import AppButton from '@/components/user-redesign/controls/AppButton.vue';
import EventInfoContent from './EventInfoContent.vue';
import mixinTime from '@/mixins/mixinTime';
import { localeFormatDefault } from '@/plugins/date-print';

export default {
  name: 'EventInfo',

  filters: {
    localeFormatDefault,
  },

  components: {
    AppButton,
    EventInfoContent,
  },

  mixins: [mixinTime],

  props: {
    data: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      openedPanel: undefined,
    };
  },

  mounted() {
    document.addEventListener('click', this.closePanel);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closePanel);
  },

  methods: {
    closePanel(event) {
      if (!this.$el.contains(event.target)) {
        this.unsetOpenedPanel();
      }
    },
    unsetOpenedPanel() {
      this.openedPanel = undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
.event-info {
  z-index: auto;

  &__panel {
    background-color: transparent !important;
    pointer-events: none;
    cursor: auto;
  }

  &__header {
    background-color: #{$redesignControlsBackground};
    border-radius: 16px;
  }

  &__title {
    max-width: 450px;
    color: #{$redesignBlack};
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  &__date {
    margin-top: 10px;
    color: #{$redesignSecondary};
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  &__btn {
    pointer-events: all;
  }

  &__content {
    // position: absolute;
    // top: 100%;
    // right: 0;
    // left: 0;
    // z-index: 2;
    border-radius: 0 0 16px 16px;

    &::v-deep .v-expansion-panel-content__wrap {
      padding: 0;
    }
  }

  &__content-wrapper {
    margin-top: 16px;
    padding: 16px;
    min-height: 30vh;
    background-color: #{$redesignControlsBackground};
    border-radius: 16px;
    pointer-events: all;
    border: 1px solid #{$redesignPrimary};
  }
}
</style>
